
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaiairportcabbooking() {



const cardData = {
  keyword: "Pune to Mumbai Airport Cab Booking ",
  heading: "Skyline Cabs: Pune to Mumbai Airport Cab Booking",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune to Mumbai Airport Cab Booking services for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from central Pune, Kharadi, Baner, Hadapsar, or Pimpri-Chinchwad, we ensure smooth and timely connectivity to Chhatrapati Shivaji Maharaj International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, comfortable, and stress-free airport transfers from Pune to Mumbai.",

  top: "Top Places to visit in Mumbai with skyline Cab",

topPlaces: [
  {
    title: "Gateway of India",
    description: "The Gateway of India, located in South Mumbai along the waterfront of Apollo Bunder, is an iconic monument built during the British Raj in 1924. Tourists arriving from Chhatrapati Shivaji Maharaj International Airport or taking sea cruises often start their Mumbai exploration here. The grand basalt arch overlooks the Arabian Sea and offers ferry services to Elephanta Caves. Its historical significance as the ceremonial entrance for British governors and royals, combined with stunning sunset views, makes it a must-visit destination for travelers seeking both heritage and photography opportunities."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, famously called the 'Queen’s Necklace,' is a 3.6 km long boulevard along Mumbai’s Arabian Sea coastline. Travelers frequently enjoy evening walks or drives along this promenade, taking in spectacular sunset views. The area is lined with Art Deco buildings, some of which are UNESCO World Heritage Sites. Street vendors, cafes, and occasional cultural performances make it a lively yet relaxing escape from busy city life, ideal for tourists and local professionals alike."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus (CSMT) is a UNESCO World Heritage Site and one of the busiest railway stations in India. Its Victorian Gothic architecture combined with Indian influences is a visual treat for visitors. Tourists and business travelers arriving by train from suburban or intercity connections often marvel at the intricate stone carvings and stained-glass windows. CSMT is also a hub for Mumbai’s local culture, offering nearby street food, historical insights, and quick access to South Mumbai attractions."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a bustling shopping street connecting the Gateway of India to the rest of South Mumbai. Tourists and local shoppers explore a mix of street markets, designer boutiques, art galleries, and iconic cafes like Leopold Cafe. Visitors traveling from the airport or railway stations frequently stop here to shop for souvenirs, handicrafts, and clothing. The vibrant atmosphere, combined with colonial-era architecture, makes it a popular destination for both leisure and cultural exploration."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park, located in Borivali, is one of the few national parks situated within a major city. Spanning over 104 square kilometers, it offers dense forests, wildlife, and the ancient Kanheri Caves. Nature enthusiasts, trekkers, and families traveling from suburban Mumbai or nearby airports visit to experience safaris, nature trails, and historical rock-cut Buddhist caves. The park also provides educational programs about conservation, making it ideal for eco-tourism and recreational trips."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is a legendary Mumbai coastline that attracts tourists, local families, and Bollywood celebrities. Visitors often come here for leisurely evening strolls, sunset photography, and sampling Mumbai’s famous street food like bhel puri and pani puri. Its proximity to luxury hotels, high-end restaurants, and entertainment hubs makes it a prime destination for travelers seeking both relaxation and vibrant local experiences."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is a 15th-century mosque and tomb located on an islet off the coast of Worli. Accessible via a narrow causeway during low tide, it is a spiritual landmark and an architectural marvel with Indo-Islamic design elements. Pilgrims, tourists, and photographers frequently visit to witness its serene ambiance and ocean views. The dargah also symbolizes Mumbai’s communal harmony and is often included in city tours highlighting heritage and culture."
  },
  {
    title: "Chor Bazaar",
    description: "Chor Bazaar, also known as the 'Thieves Market,' is one of Mumbai’s oldest and most famous flea markets. Collectors, antique enthusiasts, and tourists arrive from across India and abroad to hunt for vintage items, furniture, Bollywood memorabilia, and quirky artifacts. Its chaotic charm, bargaining culture, and proximity to Grant Road make it an intriguing destination for those looking to explore Mumbai’s local trade and street market culture."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves, a UNESCO World Heritage Site on Elephanta Island in Mumbai Harbor, are accessible via ferry from the Gateway of India. These ancient rock-cut caves date back to between the 5th and 8th centuries and feature intricate sculptures of Hindu deities, particularly Lord Shiva. Tourists often combine a ferry ride with a guided exploration of the caves, enjoying both cultural heritage and scenic views of the Arabian Sea. It is an essential destination for history buffs and spiritual travelers."
  },
  {
    title: "Bandra-Worli Sea Link",
    description: "The Bandra-Worli Sea Link is a cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai, dramatically reducing travel time. Business professionals, daily commuters, and tourists alike experience this architectural marvel for its panoramic views of the sea and skyline. Driving across at sunset is particularly popular for photographers. The bridge not only serves as a crucial transport link but has become an iconic symbol of modern Mumbai engineering and urban development."
  }
],

services: [
  {
    name: "Pune to Mumbai Airport Cab Booking",
    description: "Skyline Cabs offers professional Pune to Mumbai Airport Cab Booking service designed for punctual and stress-free airport transfers via the Mumbai–Pune Expressway. Our fleet includes well-maintained, air-conditioned sedans and SUVs suitable for long-distance travel with sufficient luggage capacity. Experienced chauffeurs monitor traffic conditions and coordinate departure timing according to flight schedules to ensure timely airport arrival. We provide structured pickup from any Pune locality with clear confirmation and route planning. Transparent pricing, disciplined highway driving standards, and dependable service management guarantee smooth airport connectivity."
  },
  {
    name: "Pune to Mumbai Airport Taxi Booking",
    description: "Pune to Mumbai Airport Taxi Booking service ensures reliable intercity airport transportation with professional chauffeur coordination. Vehicles are sanitized, comfortable, and optimized for smooth expressway travel performance. Drivers carefully plan departure timing considering city congestion and highway traffic flow. We align travel schedules with airport reporting time to prevent delays. Transparent fare breakdown, structured booking confirmation, and safe driving practices ensure dependable taxi booking solutions."
  },
  {
    name: "Pune to Mumbai Airport Cab",
    description: "Pune to Mumbai Airport Cab service delivers seamless airport transfers supported by experienced long-route drivers and comfortable vehicles. Skyline Cabs ensures punctual pickup from residential, commercial, and corporate areas across Pune. Our vehicles provide adequate luggage space and air-conditioned comfort for long-distance travel. Traffic monitoring and optimized routing guarantee smooth transit to the airport. Clear pricing policies and disciplined service execution ensure consistent reliability."
  },
  {
    name: "Pune to Mumbai Airport Taxi",
    description: "Pune to Mumbai Airport Taxi service provides efficient and secure airport transportation with structured departure coordination. Vehicles are maintained for stable highway performance and passenger comfort during expressway travel. Drivers monitor traffic updates and manage routing to ensure punctual arrival at airport terminals. We carefully align pickup timing with flight schedules for stress-free travel. Transparent billing structure and professional standards define our dependable taxi service."
  },
  {
    name: "Cab Booking Pune to Mumbai Airport",
    description: "Cab Booking Pune to Mumbai Airport service offers convenient advance reservation with assured vehicle availability and timely confirmation. Skyline Cabs ensures structured pickup coordination and optimized expressway routing for smooth airport connectivity. Vehicles are comfortable, luggage-friendly, and designed for long-distance travel efficiency. Drivers maintain punctual departure scheduling based on traffic conditions. Transparent pricing and professional service management ensure reliable booking experiences."
  },
  {
    name: "Pune to Mumbai Airport T1 Cab Booking",
    description: "Pune to Mumbai Airport T1 Cab Booking service ensures punctual transfers specifically aligned with Terminal 1 flight schedules. Skyline Cabs coordinates pickup timing carefully to meet reporting requirements for domestic departures. Vehicles are air-conditioned and suitable for comfortable long-route expressway travel. Drivers monitor traffic flow and adjust routing to prevent delays. Transparent fare structure and disciplined travel management guarantee dependable terminal connectivity."
  },
  {
    name: "Pune to Mumbai Airport T2 Cab Booking",
    description: "Pune to Mumbai Airport T2 Cab Booking service provides reliable airport transfers tailored for Terminal 2 international and domestic flights. Skyline Cabs offers comfortable vehicles with adequate luggage space for long-distance travel needs. Chauffeurs coordinate departure timing based on traffic patterns and airport reporting schedules. We ensure smooth routing through expressway corridors for punctual arrival. Transparent billing and structured coordination deliver consistent service quality."
  },
  {
    name: "Pune to Mumbai International Airport Cab Booking",
    description: "Pune to Mumbai International Airport Cab Booking service delivers structured airport transportation for international departures with professional chauffeur support. Vehicles are sanitized and maintained for smooth expressway travel performance. Drivers align departure timing with international reporting requirements and traffic updates. We ensure efficient routing and punctual arrival coordination. Transparent pricing and disciplined driving standards guarantee reliable international airport connectivity."
  },
  {
    name: "Pune to Chhatrapati Shivaji Maharaj Airport Cab",
    description: "Pune to Chhatrapati Shivaji Maharaj Airport Cab service ensures dependable expressway travel with optimized route planning and structured scheduling. Skyline Cabs provides comfortable vehicles suitable for long-distance connectivity with sufficient baggage capacity. Drivers monitor traffic conditions across Mumbai corridors to maintain punctual airport arrival. We coordinate pickup timing based on flight reporting schedules. Transparent fare policies and safety-focused service standards ensure consistent reliability."
  },
  {
    name: "Pune to Mumbai Airport Drop Taxi",
    description: "Pune to Mumbai Airport Drop Taxi service offers economical one-way airport transfers with fixed and transparent pricing. Skyline Cabs ensures punctual pickup from any Pune locality with optimized highway navigation. Vehicles are air-conditioned and maintained for smooth intercity travel performance. Drivers coordinate departure timing according to flight schedules for timely drop-offs. Clear billing structure and professional service execution guarantee dependable drop taxi solutions."
  },
  {
    name: "Hadapsar to Mumbai Airport Cab Booking",
    description: "Hadapsar to Mumbai Airport Cab Booking service provides structured pickup coordination from residential and commercial zones within Hadapsar locality. Skyline Cabs ensures comfortable vehicles optimized for expressway travel with adequate luggage accommodation. Drivers monitor traffic updates near Hadapsar and adjust departure timing accordingly. We align airport arrival schedules with flight reporting requirements. Transparent pricing and disciplined service standards guarantee reliable airport connectivity."
  },
  {
    name: "Hinjewadi to Mumbai Airport Taxi Booking",
    description: "Hinjewadi to Mumbai Airport Taxi Booking service delivers punctual airport transfers tailored for IT professionals and corporate travelers. Skyline Cabs coordinates pickup from Hinjewadi phases with optimized expressway routing. Vehicles are maintained for long-distance comfort and smooth highway performance. Drivers manage departure timing strategically to prevent delays. Transparent fare structure and professional booking management ensure dependable taxi services."
  },
  {
    name: "Wakad to Mumbai Airport Cab Booking",
    description: "Wakad to Mumbai Airport Cab Booking service ensures smooth airport transfers supported by experienced chauffeurs and optimized route planning. Skyline Cabs provides air-conditioned vehicles suitable for long-distance expressway connectivity. Departure scheduling is aligned with flight reporting time for punctual arrival. Drivers monitor traffic flow and adjust routing accordingly. Transparent pricing and structured service execution guarantee reliable booking solutions."
  },
  {
    name: "Baner to Mumbai Airport Taxi Booking",
    description: "Baner to Mumbai Airport Taxi Booking service offers dependable airport transportation with structured pickup coordination and professional driving standards. Skyline Cabs ensures comfortable vehicles designed for efficient highway travel. Drivers carefully manage departure timing considering traffic congestion across Baner and expressway corridors. Airport arrival is aligned with flight schedules to avoid delays. Transparent billing and disciplined service management ensure consistent reliability."
  },
  {
    name: "Pimpri Chinchwad to Mumbai Airport Cab Booking",
    description: "Pimpri Chinchwad to Mumbai Airport Cab Booking service provides secure and punctual airport transfers from PCMC zones. Skyline Cabs offers well-maintained vehicles optimized for long-distance highway performance. Drivers plan departure timing based on local traffic patterns and expressway flow. We ensure timely airport drop-offs aligned with flight reporting schedules. Transparent fare policies and professional service standards guarantee dependable connectivity."
  },
  {
    name: "Kharadi to Mumbai Airport Cab Booking",
    description: "Kharadi to Mumbai Airport Cab Booking service delivers structured airport transfers supported by experienced drivers and optimized routing. Skyline Cabs ensures timely pickup from residential complexes and corporate parks in Kharadi. Vehicles are air-conditioned and suitable for smooth expressway travel with sufficient luggage space. Departure scheduling is aligned carefully with airport reporting time. Transparent pricing and disciplined service coordination ensure reliable airport connectivity."
  }
],

tableData: [
  ["Pune to Mumbai Airport Cab Booking", "Pune to Mumbai Airport Taxi Booking"],
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Airport Taxi"],
  ["Cab Booking Pune to Mumbai Airport", "Pune to Mumbai Airport T1 Cab Booking"],
  ["Pune to Mumbai Airport T2 Cab Booking", "Pune to Mumbai International Airport Cab Booking"],
  ["Pune to Chhatrapati Shivaji Maharaj Airport Cab", "Pune to Mumbai Airport Drop Taxi"],
  ["Hadapsar to Mumbai Airport Cab Booking", "Hinjewadi to Mumbai Airport Taxi Booking"],
  ["Wakad to Mumbai Airport Cab Booking", "Baner to Mumbai Airport Taxi Booking"],
  ["Pimpri Chinchwad to Mumbai Airport Cab Booking", "Kharadi to Mumbai Airport Cab Booking"]
],

whychoose: [
  {
    WhyChooseheading: "Pune City Pickup Expertise",
    WhyChoosedescription: "Skyline Cab drivers have deep knowledge of Pune city roads, traffic-prone areas, and popular pickup points including Koregaon Park, Kalyani Nagar, Swargate, and Hinjewadi. This local expertise allows them to navigate efficiently, avoid congestion, and plan the fastest route for your Mumbai Airport transfer. Real-time traffic monitoring ensures timely pickups, making your journey from Pune to Mumbai Airport seamless and stress-free."
  },
  {
    WhyChooseheading: "Experienced Expressway Driving",
    WhyChoosedescription: "Our chauffeurs are highly trained for long-distance travel on the Pune–Mumbai Expressway, maintaining safe speeds, smooth handling, and proper lane discipline. Familiarity with highway conditions, toll plazas, and alternative routes ensures a comfortable, secure, and punctual ride. Skyline Cab guarantees a reliable transfer experience from Pune to Mumbai Airport, regardless of peak traffic or weather conditions."
  },
  {
    WhyChooseheading: "On-Time Airport Arrival Guarantee",
    WhyChoosedescription: "We prioritize punctuality for all airport transfers. Skyline Cab plans pickups carefully by considering traffic patterns, travel distance, and airport check-in requirements. This ensures you reach Mumbai Airport well in advance of your flight, eliminating last-minute stress and allowing sufficient time for security and boarding procedures."
  },
  {
    WhyChooseheading: "Transparent and Upfront Pricing",
    WhyChoosedescription: "Skyline Cab provides clear, upfront fare quotes for Pune to Mumbai Airport trips, covering tolls, driver allowance, and applicable taxes with no hidden charges. This transparency helps passengers plan their travel budget confidently while enjoying high-quality, reliable service."
  },
  {
    WhyChooseheading: "24/7 Availability for Airport Transfers",
    WhyChoosedescription: "Our airport cab service operates round-the-clock, accommodating early morning, late-night, and emergency flights. Skyline Cab’s 24/7 support team coordinates driver assignments, provides real-time updates, and ensures that your Pune to Mumbai Airport transfer is always ready, reliable, and convenient."
  },
  {
    WhyChooseheading: "Comfortable and Sanitized AC Vehicles",
    WhyChoosedescription: "We provide well-maintained, air-conditioned vehicles with spacious seating and ample luggage space, ideal for long-distance airport travel. Regular sanitation and safety checks ensure a hygienic and comfortable ride for solo travelers, families, and corporate clients alike."
  },
  {
    WhyChooseheading: "Corporate and Leisure-Friendly Service",
    WhyChoosedescription: "Skyline Cab caters to executives, business travelers, and leisure passengers. Professional drivers provide courteous service, luggage assistance, and a smooth ride experience. Whether you are heading to a business meeting or catching a flight for leisure, our Pune to Mumbai Airport cab ensures a comfortable and punctual journey."
  },
  {
    WhyChooseheading: "Dedicated Customer Support",
    WhyChoosedescription: "Our customer support team actively monitors every trip from booking to drop-off, providing driver details, live updates, and quick assistance for any changes. Skyline Cab ensures a hassle-free, dependable, and stress-free Pune to Mumbai Airport transfer experience every time."
  }
]


}

const faqData = [
    {
        id: 1,
        question: 'How can I complete Pune to Mumbai Airport Cab Booking with Skyline Cabs?',
        answer:
            'Completing your Pune to Mumbai Airport Cab Booking with Skyline Cabs is quick and extremely convenient. Simply visit our website or mobile app, enter Pune as your pickup location and Mumbai Airport (T1 or T2) as your drop destination, select your preferred vehicle, and confirm instantly. You will receive immediate booking confirmation along with complete driver and vehicle details. Our system ensures smooth, reliable, and stress-free airport transfer planning.',
    },
    {
        id: 2,
        question: 'Is Pune to Mumbai Airport Cab Booking available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Pune to Mumbai Airport Cab Booking service for early morning departures, midnight arrivals, and peak-hour travel. Whether you are traveling from Baner, Hinjewadi, Hadapsar, Kothrud, or any part of Pune, our drivers ensure punctual pickup and timely airport drop. We understand the importance of flight schedules and prioritize on-time service for every passenger.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Pune to Mumbai Airport Cab Booking?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Pune to Mumbai Airport Cab Booking. You can choose economical sedans for budget travel or spacious SUVs for family and group transfers. All vehicles are well-maintained, air-conditioned, sanitized, and driven by experienced professional chauffeurs for maximum comfort and safety.',
    },
    {
        id: 4,
        question: 'How much is the Pune to Mumbai Airport Cab Booking fare?',
        answer:
            'The Pune to Mumbai Airport Cab Booking fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing model where the final fare is shown before booking confirmation. The price includes driver allowance and applicable charges, ensuring no hidden fees or last-minute surprises.',
    },
    {
        id: 5,
        question: 'Is one-way Pune to Mumbai Airport Cab Booking available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Pune to Mumbai Airport Cab Booking service. You only pay for the distance traveled without unnecessary return charges. This makes it ideal for business travelers, students, families, and individuals looking for convenient airport transfers.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Pune to Mumbai Airport by cab?',
        answer:
            'The journey from Pune to Mumbai Airport typically takes around 3 to 4 hours depending on traffic conditions and time of travel. Our drivers use the Mumbai-Pune Expressway and the best available routes to ensure smooth, safe, and comfortable long-distance travel.',
    },
    {
        id: 7,
        question: 'Is online payment available for Pune to Mumbai Airport Cab Booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payment options including UPI, credit cards, debit cards, and net banking. Once your payment is completed successfully, you receive instant booking confirmation along with driver and trip details for complete peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Pune to Mumbai Airport Cab Booking in advance?',
        answer:
            'Absolutely. You can pre-book your Pune to Mumbai Airport Cab Booking for any future date and time. Advance booking ensures guaranteed vehicle availability, especially during peak travel seasons, weekends, holidays, and corporate travel rush.',
    },
    {
        id: 9,
        question: 'Does Skyline Cabs provide Mumbai Airport terminal drop options?',
        answer:
            'Yes, Skyline Cabs provides precise terminal drop options for both Mumbai Airport Terminal 1 and Terminal 2. During Pune to Mumbai Airport Cab Booking, you can select your terminal to ensure accurate and hassle-free airport drop service.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Pune to Mumbai Airport Cab Booking?',
        answer:
            'Skyline Cabs is trusted for Pune to Mumbai Airport Cab Booking because of our transparent pricing, professional drivers, sanitized vehicles, punctual airport transfers, and 24x7 customer support. We focus on delivering safe, reliable, and comfortable airport travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Rohit Deshmukh",
        rating: 5,
        review: "Booked Pune to Mumbai Airport Cab Booking with Skyline Cabs for my international flight. The driver was punctual, the vehicle was clean, and the journey was smooth via expressway. Highly reliable airport transfer service!"
    },
    {
        name: "Ms. Neha Kulkarni",
        rating: 4,
        review: "Very dependable Pune to Mumbai Airport Cab Booking service. Transparent pricing and comfortable ride made our airport travel completely stress-free. Skyline Cabs provides professional and timely service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab Booking",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-airport-cab-booking.jpg",
  "description": "Book Pune to Mumbai Airport Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. One-way and round-trip cab options available with AC, Innova Crysta, Ertiga, and Sedan cabs from Pune to Mumbai Airport Terminals 1 & 2, Chhatrapati Shivaji Maharaj International Airport, and domestic airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2699",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-airport-cab-booking"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Mumbai Airport Cab Booking | AC Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, and Sedan cabs available from Pune to Mumbai Airport Terminals 1 & 2, and Chhatrapati Shivaji Maharaj International Airport." 
  />
  <meta 
    name="keywords" 
    content="pune to mumbai airport cab booking, one way cab pune to mumbai, pune mumbai cab service, pune to mumbai taxi service, pune mumbai cab one way, best pune to mumbai cab service, best cab service from pune to mumbai airport, one way cab pune to mumbai airport, pune mumbai airport cab service, pune mumbai taxi service fare, Pune to Mumbai Airport Cab Booking, Pune to Mumbai Airport Taxi Booking, Pune to Mumbai Airport Cab, Pune to Mumbai Airport Taxi, Cab Booking Pune to Mumbai Airport, Pune to Mumbai Airport T1 Cab Booking, Pune to Mumbai Airport T2 Cab Booking, Pune to Mumbai International Airport Cab Booking, Pune to Chhatrapati Shivaji Maharaj Airport Cab, Skyline Cabs Pune to Mumbai Airport" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/142.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportcabbooking;